import {
    Typography,
    Grid,
    Avatar
} from '@material-ui/core';
import { injectIntl } from 'react-intl';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import { LEAD_EXTERNAL_STATUSES } from 'config'
import { CustomTextInput, CustomTable } from 'components'
import { tableOptions } from 'pages/common';
import ModalWrap from 'components/Modals/ModalWrap';

const OrderDetails = props => {
    const {
        intl: { formatMessage },
        open: data,
    } = props;

    const closeModal = () => {
        props.handleClose()
    }
    const documentTableColumns = [
        {
            name: "gender",
            label: "Civilité",
            options: {
                display: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return formatMessage({ id: "cart.gender." + value })
                }
            }
        },
        {
            name: "lastName",
            label: "Nom",
            options: {
                display: true,
                sort: true,
            }
        },
        {
            name: "firstName",
            label: "Prénom",
            options: {
                display: true,
                sort: true,
            }
        },
        {
            name: "birth",
            label: "Date de naissance",
            options: {
                display: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return value ? moment(value).format("DD/MM/YYYY") : ""
                }
            }
        },
        {
            name: "company",
            label: "Entreprise",
            options: {
                display: true,
                sort: true
            }
        },
        {
            name: "picture",
            label: "Photo",
            options: {
                display: true,
                sort: true,
                customBodyRender: useCallback((value, tableMeta) => {
                    return value ? <Avatar alt={"photo"} src={value} style={{ width: 30, height: 30 }} /> : ""
                }, [])
            }
        },
    ];
    return (
        <ModalWrap
            title={formatMessage({ id: "details" })}
            open={!!data}
            closeModal={closeModal}
        >
            <div>
                <div>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Libellé produit'}
                                value={data?.source.title}
                                disabled
                                multiline
                                rows={3}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Date'}
                                value={moment(data?.createdAt).format("DD/MM/YYYY")}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={"Quantité"}
                                value={data?.source.quantity || "1"}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Montant HT'}
                                value={data?.source.price + "€"}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Statut'}
                                value={formatMessage({
                                    id: 'action.status.' + (!LEAD_EXTERNAL_STATUSES.includes(data?.statusExternal) ? LEAD_EXTERNAL_STATUSES[0] : data?.statusExternal),
                                })}
                                disabled
                            />
                        </Grid>
                    </Grid>
                </div>
                <br />
                <br />
                {
                    data?.source?.trainees?.length > 0 &&
                    <>
                        <Typography variant="h5"><strong>Participant(s)</strong></Typography>
                        <CustomTable
                            columns={documentTableColumns}
                            data={data.source.trainees}
                            options={{
                                ...tableOptions(),
                            }}
                        />
                    </>
                }
            </div>
        </ModalWrap>
    );
};

OrderDetails.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }),
    open: PropTypes.any,
    handleClose: PropTypes.func
};

export default injectIntl(OrderDetails);
